import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import {
  MATCH_STATUS_HIDDEN,
  MATCH_STATUS_PENDING_DATE,
  MATCH_STATUS_NOT_STARTED,
} from "../utils/constants";

const MatchSummary = ({
  matchId,
  status,
  matchDate,
  playerAusername,
  playerAresult,
  playerAaw,
  playerBusername,
  playerBresult,
  playerBaw,
  divisionName,
  spoiler,
}) => {
  const showSpoiler =
    spoiler === undefined || spoiler === null || spoiler ? true : false;
  const winnerA =
    showSpoiler &&
    (playerAresult > playerBresult || (playerAaw && playerAaw === "AW"));
  const winnerB =
    showSpoiler &&
    (playerBresult > playerAresult || (playerBaw && playerBaw === "AW"));

  const notPlayed =
    status === MATCH_STATUS_NOT_STARTED || status === MATCH_STATUS_PENDING_DATE;

  const match_date =
    matchDate &&
    matchDate.length > 0 &&
    matchDate != null &&
    status === MATCH_STATUS_NOT_STARTED ? (
      new Date(matchDate).toLocaleString("es-ES", {
        timeZone: "Europe/Madrid",
      })
    ) : (
      <i>Pendiente fecha</i>
    );

  if (status === MATCH_STATUS_HIDDEN) {
    return (
      <WrapperPending className={`matchId-${matchId}`}>
        Partida no publicada todavía.
      </WrapperPending>
    );
  }
  if (playerAusername === "DESCANSA" || playerBusername === "DESCANSA") {
    return (
      <WrapperBye>
        <b>Jornada de DESCANSO</b>
      </WrapperBye>
    );
  }

  const getDivNameShort = (divName) => {
    var toRet = divName;
    if (divName === "Espadas Largas") {
      toRet = "Esp. Largas";
    }
    if (divName === "Hombre de Armas") {
      toRet = "H. de Armas";
    }
    return toRet;
  };

  return (
    <Wrapper>
      <Link to={`/match/${matchId}/detail`} className="link-match">
        <div
          className={`match-row  ${
            status === MATCH_STATUS_NOT_STARTED ||
            status === MATCH_STATUS_PENDING_DATE
              ? "date-game"
              : "no-date"
          }`}
        >
          {status === MATCH_STATUS_NOT_STARTED ||
          status === MATCH_STATUS_PENDING_DATE ? (
            <b>{match_date}</b>
          ) : (
            ""
          )}
        </div>
        <div className={`match-row ${divisionName && "show-div"}`}>
          <span className={winnerA ? "winner-player" : ""}>
            {playerAusername}
          </span>
          {!notPlayed ? (
            <span className={winnerA ? "winner" : "looser"}>
              {showSpoiler
                ? `${playerAaw ? playerAaw : ""} ${playerAresult}`
                : "?"}
            </span>
          ) : (
            ""
          )}
        </div>
        <div className={`match-row ${divisionName && "show-div"}`}>
          <span className={winnerB ? "winner-player" : ""}>
            {playerBusername}
          </span>
          {!notPlayed ? (
            <span className={winnerB ? "winner" : "looser"}>
              {showSpoiler
                ? `${playerBaw ? playerBaw : ""} ${playerBresult}`
                : "?"}
            </span>
          ) : (
            ""
          )}
        </div>
      </Link>
      {divisionName && (
        <div className="div-name">{getDivNameShort(divisionName)}</div>
      )}
    </Wrapper>
  );
};

const WrapperBye = styled.section`
  border: solid 1px var(--clr-grey-1);
  border-radius: 8px;
  width: 16rem;
  height: 6rem;
  margin: 0.5rem;
  padding: 0rem;
  font-size: 0.8rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: var(--clr-grey-5);
  color: var(--clr-black);
`;

const WrapperPending = styled.section`
  border: solid 1px var(--clr-grey-1);
  border-radius: 8px;
  width: 16rem;
  height: 6rem;
  margin: 0.5rem;
  padding: 0rem;
  font-size: 0.8rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Wrapper = styled.section`
  position: relative;
  border: solid 1px var(--clr-grey-1);
  border-radius: 8px;
  width: 16rem;
  height: 6rem;
  margin: 0.5rem;
  padding: 0rem;
  font-size: 0.8rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  .link-match {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .match-row {
    display: flex;
    justify-content: space-between;
    padding: 0.3rem;
    margin-top: 0rem;
    margin-bottom: 0rem;
    margin-left: 0.2rem;
    margin-right: 0.2rem;
    height: 2rem;
  }
  .date-game {
    margin-left: 0rem;
    margin-right: 0rem;
    background-color: var(--clr-grey-1);
    color: var(--clr-black);
    display: flex;
    justify-content: center;
    align-items: center;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }
  .no-date {
    height: 0;
    padding: 0;
    margin: 0;
  }
  .winner-player {
    font-weight: bold;
  }
  .winner {
    color: var(--clr-green-dark);
  }
  .looser {
    color: var(--clr-red-dark);
  }

  .div-name {
    position: absolute;
    transform: rotate(-90deg);
    transform-origin: top left;
    left: 0;
    top: 6rem;
    background-color: var(--clr-grey-1);
    color: black;
    width: 6rem;
    padding: 0.5rem;
    text-align: center;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }
  .show-div {
    margin-left: 2.5rem;
  }
`;

export default MatchSummary;
